<template>
  <div id="authority-dialog">
    <div class="authority-dialog-title">
      <div class="authority-dialog-title-texts">
        <div class="authority-dialog-title-text">
          <span>模块: {{ data.modelName }}</span>
          <el-switch v-model="data.modelShow"> </el-switch>
        </div>
        <div class="authority-dialog-title-texts-cards">
          <!-- 选择子菜单 -->
          <div
            :class="{
              'authority-dialog-title-texts-card': true,
              'is-active': cardIndex == index,
            }"
            v-for="(item, index) in data.modelMenuAuthor"
            :key="index"
            @click="drawerOper(item, index)"
          >
            {{ item.menu }}
          </div>
        </div>
      </div>
    </div>
    <div class="authority-dialog-content">
      <div class="authority-dialog-content-title">
        <span>可见性:</span
        ><el-switch v-model="data.modelMenuAuthor[cardIndex].isShow">
        </el-switch>
      </div>
      <div class="authority-dialog-content-lines-but">
        <div
          class="authority-dialog-content-line"
          v-for="(item, index) in data.authorData[cardIndex].buttonAuth"
          :key="index"
        >
          <span>{{ item.title }}:</span
          ><el-radio-group
            v-model="item.value"
            :disabled="!data.modelMenuAuthor[cardIndex].isShow"
          >
            <el-radio :label="1">读写</el-radio>
            <el-radio :label="2">只读</el-radio>
            <el-radio :label="3">不可见</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="authority-dialog-content-lines">
        <div
          class="authority-dialog-content-line"
          v-for="(item, index) in data.authorData[cardIndex].data"
          :key="index"
        >
          <span>{{ item.title }}:</span
          ><el-radio-group
            v-model="item.value"
            :disabled="!data.modelMenuAuthor[cardIndex].isShow"
          >
            <el-radio :label="1">读写</el-radio>
            <el-radio :label="2">只读</el-radio>
            <el-radio :label="3">不可见</el-radio>
          </el-radio-group>
        </div>
      </div>
      <!-- 字典值权限区域（如客户片区可见值） -->
      <div
        class="authority-dialog-content-dict"
        v-if="data.dictPermissions && data.dictPermissions.length > 0"
      >
        <div
          class="authority-dialog-content-dict-item"
          v-for="(dictPerm, dpIndex) in data.dictPermissions"
          :key="dpIndex"
        >
          <div class="authority-dialog-content-dict-title">
            <span>{{ dictPerm.name }}:</span>
            <el-switch
              v-model="dictPerm._enabled"
              @change="onDictPermSwitchChange(dictPerm)"
            >
            </el-switch>
          </div>
          <div
            class="authority-dialog-content-dict-checkboxes"
            v-if="dictPerm._enabled"
          >
            <el-checkbox-group
              v-model="dictPerm._visibleValues"
              @change="onDictPermCheckboxChange(dictPerm)"
            >
              <el-checkbox
                v-for="(dv, dvIndex) in dictPerm.dictionaryValues"
                :key="dvIndex"
                :label="dv.value"
              >
                {{ dv.name }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["authorityData"],
  data() {
    return {
      data: this.authorityData,
      cardIndex: 0,
    };
  },
  watch: {
    authorityData() {
      //父组件值变化->>子组件也变化
      this.data = this.authorityData;
      this.initDictPermissions();
    },
    data(newvalue) {
      //上一步的子组件(data)变化 提交给父组件事件 进行页面数据的更新
      this.$emit("show", newvalue);
    },
  },
  mounted() {
    this.initDictPermissions();
  },
  methods: {
    /**
     * 初始化字典值权限数据
     * 解析 authority 字段，设置已选中的字典值
     * @author lcj
     * @date 2026-06-17
     */
    initDictPermissions() {
      if (!this.data.dictPermissions || this.data.dictPermissions.length === 0) {
        return;
      }
      this.data.dictPermissions.forEach((dictPerm) => {
        // 初始化 _enabled 和 _visibleValues
        if (dictPerm._initialized) {
          return;
        }
        dictPerm._initialized = true;
        // 解析 authority："3" 表示不可见，JSON 字符串表示有选中值
        if (
          dictPerm.authority &&
          dictPerm.authority !== "3"
        ) {
          try {
            const parsed = JSON.parse(dictPerm.authority);
            dictPerm._visibleValues = parsed.visible || [];
            dictPerm._enabled = true;
          } catch (e) {
            dictPerm._visibleValues = [];
            dictPerm._enabled = false;
          }
        } else {
          dictPerm._visibleValues = [];
          dictPerm._enabled = false;
        }
        // 确保 _visibleValues 是响应式的
        this.$set(dictPerm, "_visibleValues", dictPerm._visibleValues || []);
        this.$set(dictPerm, "_enabled", dictPerm._enabled || false);
      });
    },
    /**
     * 字典值权限开关变化
     * @author lcj
     * @date 2026-06-17
     */
    onDictPermSwitchChange(dictPerm) {
      if (!dictPerm._enabled) {
        // 关闭开关 → 清空选中，authority 恢复为 "3"
        dictPerm._visibleValues = [];
        dictPerm.authority = "3";
      }
      this.$emit("show", this.data);
    },
    /**
     * 字典值权限复选框变化
     * @author lcj
     * @date 2026-06-17
     */
    onDictPermCheckboxChange(dictPerm) {
      if (dictPerm._visibleValues && dictPerm._visibleValues.length > 0) {
        dictPerm.authority = JSON.stringify({
          visible: dictPerm._visibleValues,
        });
      } else {
        // 全部取消选中 → 恢复不可见
        dictPerm.authority = "3";
      }
      this.$emit("show", this.data);
    },
    drawerOper(data, index) {
      this.cardIndex = index;
    },
  },
};
</script>

<style lang="less" scoped>
#authority-dialog {
  width: 100%;
  height: 840px;
  .authority-dialog-title {
    width: 100%;
    height: 45px;
    display: flex;
    // position: fixed;
    border-bottom: 1px solid @boderColor;
    .authority-dialog-title-texts {
      flex: 1;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      font-size: 12px;
      margin-left: 0;
      .authority-dialog-title-text {
        width: 70%;
        flex: 1;
        margin-left: 20px;
        display: flex;
        span {
          margin-right: 10px;
        }
        // justify-content: space-between;
      }
      .authority-dialog-title-texts-cards {
        flex: 1;
        display: flex;
        .authority-dialog-title-texts-card {
          width: auto;
          margin: 0 10px;
          padding: 0 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-bottom: 1px solid rgba(255, 255, 255, 0);
        }
        .authority-dialog-title-texts-card:hover {
          cursor: pointer;
          color: @activeColor;
        }
        .is-active {
          color: @activeColor;
          border-bottom: 1px solid @activeColor;
        }
      }
    }
  }
  .authority-dialog-content {
    width: 98%;
    flex: 1;
    max-height: 800px;
    display: flex;
    flex-direction: column;
    margin: 0 10px;
    // margin-top: 45px;
    margin-bottom: 40px;
    overflow-y: auto;
    font-size: @contentFontSize5;

    &::-webkit-scrollbar {
      width: 1px;
    }
    .authority-dialog-content-title {
      width: 100%;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      font-size: 12px;
      span {
        margin-right: 10px;
      }
    }
    .authority-dialog-content-lines,
    .authority-dialog-content-lines-but {
      width: 90%;
      height: auto;
      overflow: auto;
      display: flex;
      flex-direction: column;

      &::-webkit-scrollbar {
        width: 1px;
      }
      //   padding: 10px;
      .authority-dialog-content-line {
        width: 100%;
        height: 35px;
        min-height: 35px;
        display: flex;
        align-items: center;
        span {
          width: 150px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          margin-right: 10px;
        }
      }
    }
    .authority-dialog-content-lines-but {
      border-bottom: 1px solid @activeColor;
      margin-bottom: 10px;
      max-height: 300px;
    }
    .authority-dialog-content-lines {
      max-height: 500px;
    }
    .authority-dialog-content-dict {
      width: 90%;
      max-height: 300px;
      overflow-y: auto;
      margin-top: 10px;
      border-top: 1px solid @activeColor;
      padding-top: 10px;
      .authority-dialog-content-dict-item {
        width: 100%;
        margin-bottom: 10px;
        .authority-dialog-content-dict-title {
          width: 100%;
          height: 30px;
          display: flex;
          align-items: center;
          span {
            margin-right: 10px;
            font-weight: 600;
          }
        }
        .authority-dialog-content-dict-checkboxes {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          padding-left: 10px;
          .el-checkbox {
            margin-right: 15px;
            margin-bottom: 5px;
          }
        }
      }
    }
  }
}
</style>